exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n", ""]);

// exports
exports.locals = {
	"menuText": "#000",
	"menuActiveText": "#225BFC",
	"subMenuActiveText": "#225BFC",
	"menuBg": "#fff",
	"menuHover": "rgba(34,91,252,0.2)",
	"subMenuBg": "#fff",
	"subMenuHover": "rgba(34,91,252,0.2)",
	"sideBarWidth": "3.2rem"
};